// Ekran turlarının sırası ve seçimi.
//
// Bu İKİNCİ BİR LİSTEDİR ve deponun "türet, yeniden yazma" kuralına aykırıdır.
// Kabul edilmesinin sebebi, taşıdığı bilginin başka hiçbir yerde yazılı
// olmaması: "bu ekranda önce birincil eylemi, sonra filtreyi anlat" bir
// pedagojik karardır ve DOM sırasından türetilemez — DOM sırası öğretim sırası
// değildir, ve aktif olmayan bir sekmenin içindeki eleman DOM'da hiç yoktur.
//
// Savunma listeyi yasaklamak değil, BAYATLADIĞINDA SESSİZ KALMASINI yasaklamak:
// screen-tours.test.ts dört maddesi. Menüye ekran ekleyip buraya satır
// eklememek derlemeyi kırar.
//
// Anahtarlar menu-config item key'leri VERBATIM (tire korunur), tıpkı
// tour.page.* segmentleri gibi. Çapa id'leri için anchors.ts'e bakın: çoğu
// tasarım sisteminin zaten yazdığı data-component'lerden çözülür.

/**
 * Ekran → o ekranda gezilecek çapalar, GÖSTERİM SIRASINDA.
 *
 * Bir ekranın taşımadığı parça buraya YAZILMAZ. Çalışma zamanı çözemediği adımı
 * zaten atlar, ama manifest'e yazmak "burada bir filtre çubuğu var" demektir ve
 * yoksa bu bir yalandır — ve geçit bu yalanı YAKALAYAMAZ (bkz. screen-tours.test.ts
 * 1. maddesinin sınırı). Satır eklemeden önce ekranı tarayıcıda ölç:
 *
 *   document.querySelector('main').querySelectorAll('[data-component="tabs"]').length
 *
 * DİKKAT (SEM-7199): bu satır `benefits`, `surveys` ve `onboarding`'te **0**
 * döner ama üçünde de şerit VARDIR. O üç ekran `Tabs` bileşenini bıraktı ve
 * gerçek alt rotalara geçti; şeridi artık `ShellTabsNav` çiziyor ve o
 * `data-component="tabs"` değil `data-tour="tabs"` taşıyor. `resolveAnchor`
 * `data-tour`'u ÖNCE denediği için çapa çözülür. Ölçerken ikisine birden bak.
 *
 * `people` tam olarak bu şekilde yanlış yazıldı: manifest `filters` diyordu,
 * /people'da filtre çubuğu yok (departman seçici bir <select>), ve tur sessizce
 * dört yerine üç adım koştu.
 *
 * SIRA KURALI: ekranın görsel akışı, yukarıdan aşağı. Sıra tahmin EDİLMEZ,
 * belge sırasından okunur — `me-org`, `org` ve `surveys`'te sekmeler
 * istatistik şeridinden önce geliyor ve tahmin ters yazardı.
 *
 * Gerekçe spotlight'a özgü: halka adımlar arasında yürüyor ve yukarı-aşağı
 * zıplayan bir halkayı takip etmek, aşağı inen bir halkayı takip etmekten
 * belirgin biçimde zor. Sapma meşru ama sessiz olamaz — sapan satır kendi
 * gerekçesini taşır (bkz. `help-center`).
 *
 * ÜST SINIR ÜÇ ADIM. Dördüncü adım neredeyse her zaman dolgudur; ekranın geri
 * kalanı `HelpHint` "?" işaretlerine aittir (bkz. TOUR_SPOTLIGHT_DESIGN §5).
 *
 * ALT SINIR YOK, ve `me-surveys` bunun bilinçli örneğidir: o ekranın taşıdığı
 * her şey tek bir kart. İkinci adım uydurmak yerine tek adım yazıldı — sayı
 * ekranın şeklinden gelir, hedeften değil. Tek satırlık bir tur "yarım
 * bırakılmış" değildir; gördüğünüz buysa, orada o kadar şey vardır.
 */
export const SCREEN_TOURS: Record<string, readonly string[]> = {
  // Kabuk / genel
  home: ["stats", "pending-approvals"],
  "me-notifications": ["channel-layers", "notification-groups"],
  notifications: ["stats", "filters", "search"],
  // 2026-09-06: Chromium + seeded API, one visible list anchor on each
  // route, including the empty state. Draft authority is described conditionally.
  announcements: ["announcement-list"],
  "me-announcements": ["announcement-list"],
  // Native LMS: one persistent control per screen, including empty lists.
  // Catalog's create action depends on author authority; learner status filter
  // does not imply that a completed course already has an issued certificate.
  learning: ["primary-action"],
  "me-training": ["status-select"],
  "me-compensation": ["primary-action"],
  "me-buddies": ["primary-action"],
  "me-offboarding": ["offboarding-self"],
  offboarding: ["offboarding-management"],
  experience: ["experience-report"],
  "me-forms": ["forms-list"],
  forms: ["forms-list"],
  "me-expenses": ["expenses-self"],
  expenses: ["expenses-management"],
  "me-policies": ["policies-list"],
  policies: ["policies-list"],
  "me-vehicle-requests": ["vehicle-requests-self"],
  "vehicle-requests": ["vehicle-requests-management"],
  "me-document-requests": ["document-requests-self"],
  "document-requests": ["document-requests-management"],
  "me-signature-requests": ["signature-requests-self"],
  "signature-requests": ["signature-requests-management"],
  "me-cafeteria": ["cafeteria-week"],
  "cafeteria": ["cafeteria-week", "cafeteria-editor"],
  "me-advances": ["advance-self"],
  "payroll-advances": ["advance-admin"],
  "me-staff-requisitions": ["staff-requisitions-self", "staff-requisitions-summary"],
  "staff-requisitions": ["staff-requisitions-manage"],
  "me-feedback": ["employee-feedback-list"],
  "employee-feedback": ["employee-feedback-list"],
  "employee-feedback-routing": ["employee-feedback-routing"],
  "employee-feedback-categories": ["employee-feedback-categories"],
  "employee-feedback-identities": ["employee-feedback-identities"],
  "employee-feedback-report": ["employee-feedback-report"],
  "me-reviews": ["review-list"],
  "me-one-on-ones": ["one-on-one-list"],
  "me-garnishments": ["primary-action"],

  // Self-servis
  "me-directory": ["primary-action", "stats", "view-toggle"],
  "me-team": ["table"],
  "me-documents": ["table"],
  "me-tasks": ["filters", "table"],
  "me-calendar": ["primary-action", "tabs"],
  "me-requests": ["primary-action", "tabs"],
  "me-benefits": ["tabs", "table"],
  "me-kudos": ["primary-action", "tabs"],
  // `table` burada vardiya kartının tablosu DEĞİL, kayıt tablosudur:
  // attendance-content.tsx onu `data-tour="table"` ile işaretliyor, çünkü
  // jenerik çapa belgedeki İLK data-table'ı alır ve vardiya kartı önce gelir.
  "me-attendance": ["stats", "table"],
  "me-org": ["tabs", "stats"],
  "me-assets": ["stats", "filters"],
  // Dört kart var (giriş telefonu, passkey'ler, kimlik sağlayıcılar, son
  // girişler) ama üç adım: üst sınır üç, ve telefon kartı sayfa gövdesinde
  // (tour.page.me-security) anlatılıyor. Passkey kaydet/kaldır düğmesi bilerek
  // çizilmedi (SEM-6848 / SEM-6834). Çapalar yalnız kimlik sorgusu `ok`
  // verdiğinde render edilir; diğer durumlarda adımlar sessizce atlanır ve bu
  // doğrudur.
  "me-security": ["identity-passkeys", "identity-providers", "identity-logins"],
  "me-profile": ["profile-identity", "profile-quick-links", "profile-preferences"],
  "me-leave-balance": ["primary-action", "balance-cards"],
  "me-leave-calendar": ["primary-action", "calendar-toolbar", "leave-grid"],
  "me-onboarding": ["onboarding-progress", "onboarding-tasks"],
  // İki rota, iki adım, ama hiçbir ekranda ikisi birden çözülmez: liste
  // rotasında zarf, /me/payroll/:runId'de dönem listesi render EDİLMİYOR.
  // Manifest ikisini de taşır çünkü `stepForPath` detay rotasını da bu menü
  // anahtarına bağlıyor; çözülemeyeni atlama kuralı doğru olanı seçiyor.
  "me-payroll": ["payroll-periods", "payslip-envelope"],
  "me-surveys": ["open-surveys"],
  "me-support": ["primary-action", "my-tickets"],
  // SAPMA: aralık bulucu başlık eyleminin altında ama önce geliyor —
  // help-center ile aynı gerekçe. Ekranın var oluş sebebi aralık bulmaktır;
  // turu, menüde karşılığı olmayan planlama bağlantılarıyla açmak çoğunluk
  // için yanlış cümleyle başlamak olurdu. Bağlantılar 2. adımda kalıyor
  // çünkü o yüzeye ULAŞMANIN başka yolu yok.
  "me-scheduling": ["slot-finder", "primary-action"],
  // SAPMA: arama başlık eyleminin altında ama önce geliyor. "Yeni makale"
  // yalnız yetkili kullanıcıda çizilir; ekranın var oluş sebebi aramadır ve
  // turu yönetici eylemiyle açmak, çoğunluk için yanlış cümleyle başlar.
  // Yetkisiz kullanıcıda PageHeader yuvayı yine de basar ama içi boştur;
  // `resolveAnchor` boş yuvayı çözülemez sayar, yani adım atlanır.
  "help-center": ["search", "primary-action"],

  // İK yönetimi
  people: ["primary-action", "tabs", "table"],
  "leave-balances": ["stats", "table"],
  // Çapalar /me/leave/calendar ile AYNI bileşenden gelir (tek dosya, iki rota),
  // metin değil: burada ızgara ekibi, orada kendinizi gösteriyor.
  "leave-calendar": ["primary-action", "calendar-toolbar", "leave-grid"],
  "payroll-exit": ["exit-employee"],
  "payroll-employees": ["payroll-employee"],
  "payroll-garnishments": ["primary-action"],
  "payroll-compensation": ["primary-action"],
  payroll: ["primary-action", "stats"],
  org: ["tabs", "stats"],
  kudos: ["primary-action", "stats"],
  // İki adım, çünkü ekranın her koşulda taşıdığı iki parça bu: başlık
  // eylemi ve kayıtlı rapor listesi. Sonuç tablosu ve çalıştırma geçmişi
  // ancak bir rapor seçilip çalıştırıldıktan sonra render edilir — manifest'e
  // yazmak "burada bir tablo var" demek olurdu ve ilk açılışta yalan olurdu.
  reports: ["primary-action", "saved-reports"],
  surveys: ["tabs", "stats"],
  // `table` puantaj tablosudur: admin-pdks-content.tsx onu `data-tour="table"`
  // ile işaretliyor, çünkü inceleme kuyruğu ve çizelge yayını tabloları belgede
  // önce gelir ve jenerik çapa ilkini alır.
  pdks: ["search", "filters", "table"],
  assets: ["filters", "table"],
  benefits: ["tabs", "filters", "table"],
  onboarding: ["tabs", "table"],
  tasks: ["primary-action", "filters", "table"],
  events: ["primary-action", "filters", "table"],
  requests: ["primary-action", "table"],
  "support-tickets": ["filters", "ticket-list"],

  // Ayarlar & Tanımlar
  settings: ["settings-nav", "company-profile"],
  roles: ["role-list", "permission-matrix"],
  "approval-chains": ["primary-action", "chain-subject-filter", "chain-list"],
  // İki adım, çünkü ekranın taşıdığı iki özne var: kategori ve model. Ekleme
  // formları ayrı kartlar ama kendi bölümlerinin altında duruyor; onları ayrı
  // adım yapmak aynı özneyi iki kez saymak olurdu.
  "assets-catalog": ["catalog-categories", "catalog-models"],
  // Başlık eylem yuvası taşımıyor, o yüzden `primary-action` DEĞİL: düğme
  // başlığın altında, kendi satırında duruyor ve kendi data-tour'unu taşıyor.
  "payroll-workplaces": ["workplace-new", "workplace-list"],
  // Hepsi aynı iskeleti taşıyor: başlık eylemi, kart şeridi, tablo.
  // `filters` YAZILMADI — durum düğmeleri düz `Button`, `filter-pill-bar`
  // değil; `search` de yazılmadı, arama kutusu düz `Input`. İkisi de çözülmez
  // ve manifeste yazmak "burada şu var" yalanı olurdu (ölçüldü).
  "cost-centers": ["primary-action", "stats", "table"],
  departments: ["primary-action", "stats", "table"],
  locations: ["primary-action", "stats", "table"],
  // İstatistik şeridi yok; durum seçenekleri gerçek bir filter-pill-bar.
  devices: ["primary-action", "filters", "table"],
  holidays: ["primary-action", "stats", "table"],
  schedules: ["primary-action", "stats", "table"],
  org_dimensions: ["primary-action", "stats", "table"],
  "leave-types": ["primary-action", "stats", "table"],
  "job-catalogue": ["primary-action", "stats", "table"],
};

// `PENDING_SCREEN_TOURS` BURADAYDI ve boşaldığı için — söz verildiği gibi —
// silindi. Kalıcı bir "henüz değil" kümesi bırakmak, geçidin 3. maddesini
// dilek hâline geri döndürürdü: her yeni ekran sessizce oraya düşer, kimse
// listeyi okumaz. Artık menüye ekran eklemenin tek yolu ona tur yazmaktır.

export function screenTourFor(menuKey: string): readonly string[] | null {
  // Object.hasOwn, `in` DEĞİL — bkz. anchors.ts'teki aynı gerekçe.
  return Object.hasOwn(SCREEN_TOURS, menuKey)
    ? (SCREEN_TOURS[menuKey] ?? null)
    : null;
}
